class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/active-calls`;
    }
    /**
     * Returns records of all extension calls that are in progress, ordered
     * by start time in descending order.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/active-calls
     * Rate Limit Group: Heavy
     * App Permission: ReadCallLog
     * User Permission: ReadCallLog
     */
    async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
export default Index;
